import axios from 'axios';
import axiosRetry from 'axios-retry';
import FBHelper from './fb-helper';

axiosRetry(axios, {retries: 3});

var api = axios.create({
    baseURL: 'https://mongoapi.eway.vn',
    auth: {
        username: 'admin',
        password: '79CumsU9dJuGNe9E'
    }
});

export default {

    async getPosts(params) {
        var response
        if (params.url) {
            response = await api.get(params.url)
        }
        else {
            var filter = {gid: params.gid}
            if (params.uid) {
                filter = {gid: params.gid, 'do_talks_stats.id': params.uid}
            }
            response = await api.get("/fb/post", {
                params: {
                    filter: filter,
                    sort: {
                        created_time: -1
                    },
                    pagesize: params.limit,
                    count: '', hal: 'f', np: ''
                }
            })
        }

        var posts = response.data._embedded['rh:doc']
        //=> Normalize Data
        FBHelper.expandTalks(posts).forEach(post => {
            if (post._id) post.id = post._id
            post.created_time = new Date(post.created_time.$date)
        })

        var next_page = _.get(response, 'data._links.next.href')
        return {data: posts, next_page: next_page}
    },

    async getAllUserStatsMap(gid) {
        var users_stats = []

        var link = "/fb/post/_aggrs/users_stats"
        while (true) {
            var response = await api.get(link, {
                params: {
                    avars: {gid: gid},
                    pagesize: 1000,
                    hal: 'f', np: ''
                }
            })

            var stats = response.data._embedded['rh:result']
            users_stats.push(...stats)
            if (!response.data._links.next) break;
            link = response.data._links.next.href
        }

        var users_stats_map = new Map()
        for (let user of users_stats) {
            user.score = _.round(user.get_reactions / user.do_talks, 2)
            user.id = user._id
            delete user._id
            users_stats_map.set(user.id, user)
        }

        return users_stats_map
    },

    async getUserStatsMap(gid) {
        var users_stats_map = new Map()

        var link = "/fb/post/_aggrs/users_stats"
        var response = await api.get(link, {
            params: {
                avars: {gid: gid},
                pagesize: 10,
                hal: 'f', np: ''
            }
        })

        console.log(response.data);
        var stats = response.data._embedded['rh:result']

        for (let user of stats) {
            user.score = _.round(user.get_reactions / user.do_talks, 2)
            user.id = user._id
            delete user._id
            users_stats_map.set(user.id, user)
        }

        return users_stats_map
    },

    async fetchStatsUsers({link, gid, limit = 10}) {
        var response
        if (link !== undefined) {
            response = await api.get(link)
        } else {
            response = await api.get('/fb/post/_aggrs/users_stats', {
                params: {
                    avars: {gid: gid}, pagesize: limit, hal: 'f', np: ''
                }
            })
        }

        var result = response.data._embedded['rh:result']
        var next_page = _.get(response, 'data._links.next.href')

        var users = []
        for (let user of result) {
            user.id = user._id
            delete user._id

            user.score = _.round(user.get_reactions / user.do_talks, 2)
            users.push(user)
        }
        return {data: users, meta: {next_page: next_page}}
    },

    async upsertPosts(posts) {
        posts.forEach(post => {
            post._id = post.id
            delete post.id
        })
        FBHelper.expandTalks(posts).forEach(post => {
            post.created_time = {'$date': new Date(post.created_time).getTime()}
        })

        var response = await api.post("/fb/post", posts)
    },

}



// WEBPACK FOOTER //
// ./src/libs/fb-mongo.js